<div class="single-product-container">
  <div class="img-container">
    <img src="{{ productData?.product_img }}" default="{{ defaultImage }}" />
  </div>
  <div class="content-container">
    <div class="product-info-container">
      <h2>{{ productData?.name }}</h2>
      <h1 *ngFor="let price of productData?.prices">{{ price.price + ' ' + price.currency }}</h1>
    </div>
    <div class="choose-button-container btn-container">
      <button class="choose-button" (click)="productSelected()">
        <h3>{{ 'view_translations.choose' | translate }}</h3>
      </button>
    </div>
  </div>
</div>
